
var id = "menu_order";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"menu_order\">\n<path d=\"M110.3,7.7H94.8c0-4.6-3.1-7.7-7.7-7.7H40.9c-4.6,0-7.7,3.1-7.7,7.7H17.7c-6.2,0-11.6,5.4-11.6,11.6v97.1\n\tc0,6.2,5.4,11.6,11.6,11.6h92.5c6.2,0,11.6-5.4,11.6-11.6V19.3C121.8,13.1,116.4,7.7,110.3,7.7z M40.9,11.6V7.7h46.3v7.7H40.9V11.6z\n\t M114.1,116.4c0,2.3-1.5,3.9-3.9,3.9H17.7c-2.3,0-3.9-1.5-3.9-3.9V19.3c0-2.3,1.5-3.9,3.9-3.9h15.4c0,4.6,3.1,7.7,7.7,7.7h46.3\n\tc4.6,0,7.7-3.1,7.7-7.7h15.4c2.3,0,3.9,1.5,3.9,3.9C114.1,19.3,114.1,116.4,114.1,116.4z\" />\n<path d=\"M92.1,40.8H35.9c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1h56.2c2.3,0,4.1-1.8,4.1-4.1C96.2,42.6,94.4,40.8,92.1,40.8z\n\t M92.1,64.4H35.9c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1h56.2c2.3,0,4.1-1.8,4.1-4.1S94.4,64.4,92.1,64.4z M92.1,88.1H35.9\n\tc-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1h56.2c2.3,0,4.1-1.8,4.1-4.1C96.2,89.9,94.4,88.1,92.1,88.1z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
